// Copyright (c) Bentley Systems
import { ComboBox, Label } from "@itwin/itwinui-react";
import { appendLoadMoreOption, LOAD_MORE_VALUE, paginatedItemRenderer, searchPlaceholder } from "../Helpers/ComboBoxHelpers";
import { useIModels } from "../Helpers/useIModels";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectAccessToken } from "../app/authorization-slice";

type IModelSelectorProps = {
  iTwinId: string | null;
  currentIModelId: string | null;
  onIModelChange: (iModelId: string) => void;
  disabled?: boolean;
};

const IModelSelector: React.FC<IModelSelectorProps> = ({
  iTwinId,
  currentIModelId,
  onIModelChange,
  disabled = false,
}) => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector(selectAccessToken);

  const {
    selectOptions,
    emptyContent,
    handleSearchChange,
    handleIModelSelect,
    fetchNextIModels,
    hasMore,
    isLoading,
  } = useIModels({
    iTwinId,
    currentIModelId,
    accessToken,
    dispatch,
  });

  return (
    <div className="becs-imodel-selector">
      <Label as="span" className="becs-imodel-selector-label">
        iModel
      </Label>
      <ComboBox
        options={appendLoadMoreOption(selectOptions, hasMore)}
        value={currentIModelId ?? undefined}
        onChange={(selectedId: string) => {
          if (selectedId && selectedId !== currentIModelId && selectedId !== LOAD_MORE_VALUE) {
            handleIModelSelect(selectedId);
            onIModelChange(selectedId);
          }
        }}
        inputProps={{
          placeholder: searchPlaceholder("Search iModel", 3, isLoading),
          disabled,
          onChange: handleSearchChange,
        }}
        filterFunction={(options) => options}
        emptyStateMessage={emptyContent}
        enableVirtualization
        itemRenderer={paginatedItemRenderer({
          onLoadMore: fetchNextIModels,
          isLoading,
        })}
      />
    </div>
  );
};

export default IModelSelector;
